// redirect-to-dashboard.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { getPath, PathUnit } from '@/app/consts/path.const';


export const redirectToDashboardGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // 检查用户是否已登录

  // authService.isLoggedIn();
  // const accounts = msalService.instance.getAllAccounts();
  return authService.checkLoggedIn().then(isLoggedIn => {
    if(isLoggedIn){
      router.navigate([`/${getPath(PathUnit.Dashboard)}`]);
      return false;
    } else {
      return true;
    }
  })
};